(() => {
  document.querySelectorAll('[data-countdown]').forEach(cd => {
    const end = new Date(cd.dataset.end).getTime();
    if (isNaN(end)) return;

    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      const diff = Math.max(0, end - Date.now());
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff / 3600000) % 24);
      const m = Math.floor((diff / 60000) % 60);
      const s = Math.floor((diff / 1000) % 60);
      cd.querySelector('[data-jours]').textContent = pad(d);
      cd.querySelector('[data-hres]').textContent  = pad(h);
      cd.querySelector('[data-min]').textContent   = pad(m);
      cd.querySelector('[data-sec]').textContent   = pad(s);
      if (diff === 0) cd.classList.add('is-ended');
    };
    tick();
    setInterval(tick, 1000);
  });
})();